import { headerSearch } from "../../plugins/ComponentsUi/HeaderSearch/HeaderSearch";
import { detectCloseElement } from "./helper";
/*==================== Header ====================*/
/**
 * @param header
 */
const vw = $(window).width();
export const header = {
  scrollActive: function () {
    let height = $("header").height();
    if ($(window).scrollTop() > height) {
      $("header").addClass("active");
    } else {
      $("header").removeClass("active");
    }
  },
  mobile: function () {
    $(".header-hambuger").on("click", function () {
      $("body").toggleClass("openMenuMobile");
    });
  },
  init: function () {
    headerSearch();
    header.scrollActive();
    header.mobile();
  },
};

jQuery(document).ready(function () {
  $(".header-menu .title.has-sub").on("click", function () {
    const $subMenu = $(this).next(".nav-sub");
    $subMenu
      .slideToggle()
      .parent()
      .toggleClass("active")
      .siblings()
      .removeClass("active")
      .find(".nav-sub")
      .slideUp();
  });
  $(".header-menu li i").on("click", function () {
    const $subMenu = $(this).next(".nav-sub");
    if ($subMenu.length) {
      $(".nav-sub.active").not($subMenu).removeClass("active");
      $subMenu.toggleClass("active");
    }
  });
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".header-menu li i, .nav-sub").length) {
      $(".nav-sub.active").removeClass("active");
    }
  });
});

document.addEventListener(
  "scroll",
  function (e) {
    header.scrollActive();
  },
  true
);
